export const contactInfo = {
  country: "Colombia",
  Tel: "(+57) 313 703 6415",
  email: " luz.tobarc@outlook.com",
};
